import { defineMessages } from 'react-intl';

export default defineMessages({
  retirement: {
    id: 'sentinel.components.retirementPanel.retirement',
    defaultMessage: 'Retirement',
  },
  state: {
    id: 'sentinel.components.retirementPanel.state',
    defaultMessage: 'State',
  },
  federal: {
    id: 'sentinel.components.retirementPanel.federal',
    defaultMessage: 'Federal',
  },
  distributionReason: {
    id: 'sentinel.components.retirementPanel.distributionReason',
    defaultMessage: 'Distribution Reason',
  },
  planType: {
    id: 'sentinel.components.retirementPanel.planType',
    defaultMessage: 'Plan Type',
  },
  receivingInstitution: {
    id: 'sentinel.components.retirementPanel.receivingInstitution',
    defaultMessage: 'Receiving Institution',
  },
  iraContributionDetailsType: {
    id: 'sentinel.components.retirementPanel.iraContributionDetailsType',
    defaultMessage: 'Contribution Type',
  },
  journalIraContributionDetailsType: {
    id: 'sentinel.components.retirementPanel.journalIraContributionDetailsType',
    defaultMessage: 'Contribution Type (Contra Account)',
  },
  iraContributionApplyToPriorYear: {
    id: 'sentinel.components.retirementPanel.iraContributionApplyToPriorYear',
    defaultMessage: 'Apply to Prior Year',
  },
});



// WEBPACK FOOTER //
// ./src/components/RetirementPanel/messages.js